import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyAgroWBSequentialDVSelectedChartVariables,
  setChart as setChartRedux,
} from 'redux/reducers/meteorologyAgroWBSequentialDVReducer';
import useOptions from './useOptions';

export default function useChartVariable() {
  const { options, isLoading } = useOptions();
  const chartOptions = useMemo(() => (options ? options.variables.map((variable) => ({
    id: variable.id,
    label: variable.label,
    value: variable.name,
  })) : []), [options]);

  const selectedChartVariables: number[] = useSelector(
    selectMeteorologyAgroWBSequentialDVSelectedChartVariables,
  );

  const toggleChartVariables = (ch: number) => {
    const newChart = selectedChartVariables.includes(ch)
      ? selectedChartVariables.filter((c) => c !== ch)
      : selectedChartVariables.concat(ch);
    newChart.sort();
    store.dispatch(setChartRedux(newChart));
  };

  const selectAll = useCallback(() => {
    store.dispatch(setChartRedux(chartOptions.map((c) => c.id)));
  }, [chartOptions]);

  const deselectAll = () => {
    store.dispatch(setChartRedux([]));
  };

  const allSelected = useMemo(() => (
    chartOptions.every((option) => selectedChartVariables.includes(option.id))
  ), [chartOptions, selectedChartVariables]);

  return {
    chartOptions,
    toggleChartVariables,
    selectAll,
    deselectAll,
    allSelected,
    selectedChartVariables,
    isLoading,
  };
}
